import { render, staticRenderFns } from "./UpdateUAMUserProfile.vue?vue&type=template&id=7ca68dee"
import script from "./UpdateUAMUserProfile.vue?vue&type=script&lang=js"
export * from "./UpdateUAMUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports